/**
 * Big Waster API
 * This is a Big Waster API.
 *
 * OpenAPI spec version: 1.0
 * Contact: terry.wong@futureimpactlab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import WasterecordQueryResult from './WasterecordQueryResult';

/**
 * The WasterecordOutputCmsRecords model module.
 * @module model/WasterecordOutputCmsRecords
 * @version 1.0
 */
class WasterecordOutputCmsRecords {
    /**
     * Constructs a new <code>WasterecordOutputCmsRecords</code>.
     * @alias module:model/WasterecordOutputCmsRecords
     */
    constructor() { 
        
        WasterecordOutputCmsRecords.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>WasterecordOutputCmsRecords</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/WasterecordOutputCmsRecords} obj Optional instance to populate.
     * @return {module:model/WasterecordOutputCmsRecords} The populated <code>WasterecordOutputCmsRecords</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new WasterecordOutputCmsRecords();

            if (data.hasOwnProperty('records')) {
                obj['records'] = ApiClient.convertToType(data['records'], [WasterecordQueryResult]);
            }
        }
        return obj;
    }


}

/**
 * @member {Array.<module:model/WasterecordQueryResult>} records
 */
WasterecordOutputCmsRecords.prototype['records'] = undefined;






export default WasterecordOutputCmsRecords;

